<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="shownStartDate"
                  :label="$t('Start date')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="getBCPLangCode"
                v-model="startDate"
              ></v-date-picker>
              <!--  @input="changeChartAndDataTable()" -->
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="shownEndDate"
                  :label="$t('End date')"
                  prepend-inner-icon="mdi-calendar"
                  hide-details="auto"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                :locale="getBCPLangCode"
                v-model="endDate"
              ></v-date-picker>
              <!-- @input="changeChartAndDataTable()" -->
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="6">
        <v-card outlined>
          <v-card-title>
            {{ $t("Popular articles") }}
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("Article code") }}</th>

                    <th class="text-left">{{ $t("Number of") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in reportDataTableItems"
                    :key="index"
                  >
                    <td>
                      <v-avatar class="my-2" color="white">
                        <v-img
                          alt="Avatar"
                          contain
                          :lazy-src="item.Image"
                          :src="item.Image"
                        ></v-img>
                      </v-avatar>
                      {{ item.ItemCode }}
                    </td>
                    <td>{{ item.Total }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <v-card outlined>
          <v-card-title>
            {{ $t("Revenue") }}
          </v-card-title>
          <v-card-text>
            <Bar
              v-if="!isLoading"
              ref="line"
              :chart-options="chartOptions"
              :chart-data="getChartData"
            />

            <v-progress-circular
              v-else
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
  
  <script>
import { Bar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  data() {
    return {
      startDateMenu: null,
      endDateMenu: null,
      startDate: null,
      endDate: null,
      isLoading: true,
      customers: null,
      customerId: null,
      userToken: this.$auth.userToken(),

      chartData: {
        labels: [],
        datasets: [
          {
            label: "€",
            backgroundColor: "rgba(54, 162, 235, 0.8)",
            borderRadius: 4,
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
      reportDataTableItems: [],
    };
  },
  components: {
    Bar,
  },
  created() {
    this.endDate = this.changeTimeToReadebleDMY();
    this.startDate = this.changeTimeToReadebleDMY(1);

    this.getInitalItems();
  },
  computed: {
    getChartData() {
      return this.chartData;
    },
    currentLanguage: {
      get: function () {
        return this.$i18n.locale();
      },
    },
    getBCPLangCode() {
      let lang;
      switch (this.currentLanguage) {
        case "Nl":
          lang = "nl-BE";
          break;
        case "Fr":
          lang = "fr-FR";
          break;
        case "En":
          lang = "en-GB";
          break;
      }

      return lang;
    },
    shownStartDate: {
      get: function () {
        var inputDateSplit = this.startDate.split("-");
        return (
          inputDateSplit[2] + "-" + inputDateSplit[1] + "-" + inputDateSplit[0]
        );
      },
    },
    shownEndDate: {
      get: function () {
        var inputDateSplit = this.endDate.split("-");
        return (
          inputDateSplit[2] + "-" + inputDateSplit[1] + "-" + inputDateSplit[0]
        );
      },
    },
  },
  methods: {
    changeTimeToReadebleDMY(minusYears = 0) {
      let date = new Date(),
        month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        year = date.getFullYear();

      year = year - minusYears;
      let newDate = year + "-" + month + "-" + day;
      return newDate;
    },
    getInitalItems() {
      this.reportDataTableItems = [
        {
          ItemCode: "V102-1",
          Total: 100,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-2",
          Total: 10,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V103-1",
          Total: 20,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-4",
          Total: 50,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-5",
          Total: 60,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-6",
          Total: 80,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-7",
          Total: 100,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-8",
          Total: 60,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V102-9",
          Total: 80,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V104-1",
          Total: 20,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V105-1",
          Total: 10,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V106-1",
          Total: 123,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V107-1",
          Total: 189,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V108-1",
          Total: 10,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V109-1",
          Total: 15,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V201-1",
          Total: 1000,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V202-1",
          Total: 18,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V203-1",
          Total: 80,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V204-1",
          Total: 100,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
        {
          ItemCode: "V204-1",
          Total: 90,
          Image:
            this.$config.apiUrls.Dev +
            "/images/products/" +
            "V102-1.png" +
            "?token=" +
            this.userToken,
        },
      ];
      let total = [
          1051, 2147, 3852, 10214, 6220, 8022, 5149, 4056, 8940, 5820, 5520,
          4510,
        ],
        yearMonth = [
          this.$t("January"),
          this.$t("February"),
          this.$t("March"),
          this.$t("April"),
          this.$t("May"),
          this.$t("June"),
          this.$t("July"),
          this.$t("August"),
          this.$t("September"),
          this.$t("October"),
          this.$t("November"),
          this.$t("December"),
        ];

      this.chartData.labels = yearMonth;
      this.chartData.datasets[0].data = total;
      this.isLoading = false;
    },
  },
};
</script>
  
  <style>
</style>